import type { AiManagedGroupPolicy } from "@adpilot/shared";

export function managedGroupDiagnosticsQueryKey(
  shopId: string,
  campaignIds: string[],
  policy: AiManagedGroupPolicy,
  lifecycleStatus: "active" | "paused",
) {
  return [
    "ai-managed-groups",
    "diagnostics",
    shopId,
    [...campaignIds].sort(),
    policy.businessGoal,
    policy.targetAcos,
    policy.riskPreference,
    policy.executionMode,
    lifecycleStatus,
  ] as const;
}

type ManagedGroupDiagnosticsQueryKey = ReturnType<typeof managedGroupDiagnosticsQueryKey>;

export function canReuseManagedGroupDiagnosticsPlaceholder(
  previousKey: readonly unknown[] | undefined,
  nextKey: ManagedGroupDiagnosticsQueryKey,
): boolean {
  if (!previousKey) return false;
  const previousCampaignIds = previousKey[3];
  const nextCampaignIds = nextKey[3];
  return (
    previousKey[0] === nextKey[0] &&
    previousKey[1] === nextKey[1] &&
    previousKey[2] === nextKey[2] &&
    Array.isArray(previousCampaignIds) &&
    previousCampaignIds.length === nextCampaignIds.length &&
    previousCampaignIds.every((campaignId, index) => campaignId === nextCampaignIds[index]) &&
    previousKey[8] === nextKey[8]
  );
}
